import type { ReactElement, ReactNode } from 'react';

type RequireDesktopProps = { children: ReactNode; allowOnMobile?: boolean };

export const RequireDesktop = ({ children }: RequireDesktopProps): ReactElement => <>{children}</>;
